"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/ScheduleTab/NoReplySection/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');
var _MessageForm = require('../MessageForm'); var _MessageForm2 = _interopRequireDefault(_MessageForm);

 const defaultNoReplyMessage = (orgName) =>
  `${orgName ? `${orgName}: ` : ''}This number does not accept replies. ` +
  'Please contact your care team directly. Reply STOP to opt out.'; exports.defaultNoReplyMessage = defaultNoReplyMessage















// The no-reply row, open. Turning it on fills in the default message and
// waits for Save; turning it off saves at once.
const NoReplySection = ({
  isOn, message, orgName, canEdit, loadFailed = false, onSave, onClose, onDraft,
}) => {
  const [isTurningOn, setIsTurningOn] = _react.useState.call(void 0, false)
  // Locks the switch while turning on saves, so an off can't race it.
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const showsMessage = isOn || isTurningOn

  const onToggle = (turnOn) => {
    setIsTurningOn(turnOn && !isOn)
    if (!turnOn && isOn) onSave(false)
  }

  return (
    _react2.default.createElement('div', { className: "team-page--no-reply", 'data-testid': "team-page--no-reply", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      , _react2.default.createElement(_Form.Toggle, {
        isChecked: showsMessage,
        isDisabled: !canEdit || isSaving,
        onChange: onToggle,
        label: "Every text and secure message gets this reply right away. They still reach your inbox."              ,
        warning: loadFailed ? 'Couldn\'t load the no-reply message. Reload the page to try again.' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      )
      ,  showsMessage && (canEdit
        ? (
          _react2.default.createElement(_MessageForm2.default, {
            message: isOn ? message : message || exports.defaultNoReplyMessage.call(void 0, orgName),
            canSaveUnchanged: !isOn,
            onSave: (msg) => {
              setIsSaving(true)
              return onSave(true, msg)
                .then(() => setIsTurningOn(false))
                .finally(() => setIsSaving(false))
            },
            onCancel: () => {
              setIsTurningOn(false)
              _optionalChain([onClose, 'optionalCall', _ => _()])
            },
            onDraft: onDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
          )
          )
        : _react2.default.createElement('p', { className: "team-page--message-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}},  message )
      )
    )
  )
}

exports. default = NoReplySection
